module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n ';
 if (hasControlButtons()) { 
__p+='\n    <div class="m-modal-section" >\n        <div class="m-modal-section__title">Device commands</div>\n        <div class="m-modal-row">\n            <div class="form-group">\n                <div class="realtime-controls">\n                  ';
 _.each(getControlButtons(), function(button){ 
__p+='\n                    <a class="m-btn js-control-button" role="button" data-command="'+
((__t=( button.command ))==null?'':__t)+
'" data-value="'+
((__t=( button.value ))==null?'':__t)+
'">'+
((__t=( button.label ))==null?'':__t)+
'</a>\n                  ';
 }); 
__p+='\n                </div>\n            </div>\n        </div>\n    </div>\n  ';
 } 
__p+='\n    \n \n\n   ';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/devices/control/templates/control.html
// module id = 437
// module chunks = 0